/*
 * @Author: tangff
 * @Date: 2024-05-31 14:41:06
 * @LastEditTime: 2024-05-31 17:33:08
 * @LastEditors: tangff
 * @Description: 
 * @FilePath: /lcmp/src/Pages/ModuleManage/Components/SearchBar.tsx
 * @Team: JDB FE
 */
import { Button, Form, Input, Select } from 'antd';
import { useState } from 'react';
import { SearchForm } from '../types';
import useCascadingModule from '@/Apis/hooks/queries/useCascadingModule/useCascadingModule';
import { filterOption } from '@/Utils/Utils';

interface Props {
	onSearch: (filter: SearchForm) => void;
}

const SearchBar: React.FC<Props> = ({ onSearch }) => {
	const [moduleId, setModuleId] = useState<number>();
	const [remark, setRemark] = useState<string>('');

	const {
		data: { data: module },
	} = useCascadingModule();

	const handleSearch = () => {
		onSearch({
			moduleId,
			remark
		});
	};

	return (
		<Form layout='inline'>
			<Form.Item label='Module'>
				<Select
					showSearch
					allowClear
					placeholder='Select a Module'
					optionFilterProp='children'
					style={{ width: '300px' }}
					onChange={(e) => {
						setModuleId(e);
					}}
					filterOption={filterOption}
					options={module.list.map((d) => ({
						value: d.id,
						label: `${d.name}(${d.shortName})`,
					}))}
					value={moduleId}
				/>
			</Form.Item>
			<Form.Item label='Remark'>
				<Input
					style={{ width: '300px' }}
					placeholder='Search Module Remark'
					onChange={(e) => setRemark(e.target.value)}
					value={remark}
				/>
			</Form.Item>
			<Form.Item>
				<Button
					type='default'
					htmlType='submit'
					onClick={handleSearch}
				>
					Search
				</Button>
      </Form.Item>
		</Form>
	);
};

export default SearchBar;
